import * as React from "react";
import { type HTMLProps } from "react";

interface Props extends HTMLProps<HTMLDivElement> {
    children: string;
}

export default class UnescapedContent extends React.Component<Props> {
    public render(): React.ReactNode {
        const { children, ...props } = this.props;

        return (
            <div
                {...props}
                dangerouslySetInnerHTML={{ __html: children }}
            />
        );
    }
}
